import HavokPhysics from '@babylonjs/havok';
import { HavokPlugin } from '@babylonjs/core';

/** The WASM instance is loaded once and shared; each scene gets its own plugin. */
let wasmPromise: Promise<unknown> | null = null;

export async function createHavokPlugin(): Promise<HavokPlugin> {
  if (!wasmPromise) wasmPromise = HavokPhysics();
  const hk = await wasmPromise;
  return new HavokPlugin(true, hk);
}
